var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRank2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8469 1.77342C18.7471 0.676374 21.0887 0.678774 22.9866 1.77972L29.8661 5.77043L36.7619 9.73288C38.6643 10.826 39.8372 12.8527 39.8372 15.0468V30.9615C39.8372 33.1511 38.669 35.1744 36.7728 36.2692L22.983 44.2308C21.0867 45.3256 18.7504 45.3256 16.8542 44.2308L3.0644 36.2692C1.16814 35.1744 0 33.1511 0 30.9615V15.0385C0 12.8489 1.16814 10.8256 3.0644 9.73077L16.8469 1.77342Z",
    fill: "#DEDCD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6152 6.20293L29.617 6.20395L36.5128 10.1664C38.26 11.1704 39.3372 13.0317 39.3372 15.0468V30.9615C39.3372 32.9725 38.2643 34.8307 36.5228 35.8362L22.733 43.7978C20.9914 44.8032 18.8457 44.8032 17.1042 43.7978L3.3144 35.8362C1.57284 34.8307 0.5 32.9725 0.5 30.9615V15.0385C0.5 13.0275 1.57284 11.1693 3.3144 10.1638L17.0969 2.20644C18.8421 1.19889 20.9927 1.20109 22.7357 2.21222L29.6152 6.20293Z",
    stroke: "#808080",
    strokeOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3207 10.1787L27.3225 10.1797L33.4549 13.7035C34.2509 14.1609 34.7416 15.0089 34.7416 15.9269V30.0766C34.7416 30.9928 34.2529 31.8393 33.4594 32.2974L21.2018 39.3744C20.4084 39.8324 19.4309 39.8324 18.6374 39.3744L6.37985 32.2974C5.58643 31.8393 5.09766 30.9928 5.09766 30.0766V15.9228C5.09766 15.0066 5.58643 14.16 6.37986 13.7019L18.6338 6.6271C19.4289 6.16807 20.4087 6.16908 21.2028 6.62973L27.3207 10.1787Z",
    stroke: "#808080",
    strokeOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank2);
export default __webpack_public_path__ + "static/media/rank2.1ebb99795dd85196992b5b3db61043e1.svg";
export { ForwardRef as ReactComponent };